import { AfterViewInit, Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Policy } from '../../../../../shared/models/info/policy';
import { IfPolicySatisfiedDirective } from '../../../../directives/if-policy-satisfied.directive';
import { ImportIconComponent } from '../../../icons/import-icon/import-icon.component';
import { initFlowbite } from 'flowbite';
import { CloseIconComponent } from '../../../icons/close-icon/close-icon.component';
import { ImportType } from '../../../lists/nw-number/nw-number-accordion/import-type';
import { Project } from '../../../../../shared/models/project';
import { AgentActionDirective } from '../../../../directives/agent-action.directive';

@Component({
  selector: 'app-import-project-popover',
  imports: [IfPolicySatisfiedDirective, ImportIconComponent, CloseIconComponent, AgentActionDirective],
  templateUrl: './import-project-popover.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './import-project-popover.scss',
})
export class ImportProjectPopover implements AfterViewInit {
  @Input() public project?: Project;
  @Output() public importClicked = new EventEmitter<{ project: Project; importType: ImportType }>();

  protected readonly popoverTargetId = `import-project-popover-${crypto.randomUUID()}`;
  protected readonly policy = Policy;
  protected readonly importType = ImportType;
  protected isOpen = false;

  public ngAfterViewInit(): void {
    initFlowbite();
  }
}
